import {Component, OnDestroy, OnInit} from '@angular/core';
import {SharedStateService, TenantService} from '@twpub/core/services';
import {MatMenu, MatMenuTrigger} from '@angular/material/menu';
import {MatIcon} from '@angular/material/icon';
import {MatBadge} from '@angular/material/badge';
import {FilterWrapperComponent} from '@twpub/shared/components/wrappers';
import {Subscription} from 'rxjs';
import {NgClass} from '@angular/common';

@Component({
  selector: 'pub-filter-button',
  templateUrl: './filter-button.component.html',
  styleUrls: ['./filter-button.component.scss'],
  standalone: true,
  imports: [MatMenuTrigger, MatIcon, MatBadge, MatMenu, FilterWrapperComponent, NgClass]
})
export class FilterButtonComponent implements OnInit, OnDestroy {
  isFilterOpen: boolean = false;
  available: boolean = true;
  hasActiveFilters: boolean = false;
  activeFilterCount: number = 0;

  // i18n label
  filtersHeaderLabel = $localize`:@@filters.header:Filters`;
  filterTitle = $localize`:@@filters.title:Filters`;

  private subscriptions = new Subscription();

  constructor(private tenantService: TenantService, private sharedStateService: SharedStateService) {
  }

  ngOnInit() {
    this.subscriptions.add(
      this.tenantService.getCurrentTenant().subscribe((tenantConfig) => {
        this.available = tenantConfig.indexed;
      })
    );
    this.subscriptions.add(
      this.sharedStateService.session$.subscribe((session) => {
        this.activeFilterCount = session.fieldFilters?.filter(f => f.values.length > 0).length ?? 0;
        this.hasActiveFilters = this.activeFilterCount > 0;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  toggleFilter(event: Event) {
    event.preventDefault();
    if (!this.available) return;
    this.isFilterOpen = !this.isFilterOpen;
  }

  closeFilter() {
    this.isFilterOpen = false;
  }
}
